import BaseResource from './index'

export default class UnionLocationConditionHiredResource extends BaseResource {
    static endpoint = '/oasis/restv3/admin/unionLocationConditionHired'
}
